
import get from 'lodash/get';

export function translatedFromApi(gender){
    return get({1: 'male', 2: 'female'}, gender, '');
}

export const subject = gender => ({ male: 'he', female: 'she' }[gender] || 'they')
export const object = gender => ({ male: 'him', female: 'her' }[gender] || 'them')
export const possessive = gender => ({ male: 'his', female: 'her' }[gender] || 'their')